import { combineReducers } from "@reduxjs/toolkit";
import {
  wishlistsApi,
  spreedlyCredentialsApi,
  experiencesApi,
} from "@capone/common";
import {
  wishlistManagementModalReducer,
  wishlistSnackbarReducer,
} from "halifax";

import { reducer as hotelSearch } from "../modules/search/reducer";
import { reducer as hotelAvailability } from "../modules/availability/reducer";
import { reducer as hotelShop } from "../modules/shop/reducer";
import { reducer as hotelBook } from "../modules/book/reducer";
import { reducer as hotelRewards } from "../modules/rewards/reducer";
import { reducer as hotelTravelWallet } from "../modules/travel-wallet/reducer";
import { reducer as hotelAncillary } from "../modules/ancillary/reducer";

export const rootReducer = combineReducers({
  hotelSearch,
  hotelAvailability,
  hotelShop,
  hotelBook,
  hotelRewards,
  hotelTravelWallet,
  hotelAncillary,
  [experiencesApi.reducerPath]: experiencesApi.reducer,
  [wishlistsApi.reducerPath]: wishlistsApi.reducer,
  [spreedlyCredentialsApi.reducerPath]: spreedlyCredentialsApi.reducer,
  wishlistManagementModal: wishlistManagementModalReducer,
  wishlistSnackbar: wishlistSnackbarReducer,
});
